import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getAvailableViews } from '../api/availableViews';
import { SurveyDataManagerApiError } from '../contracts/common';
import { AvailableViewsResponseBody } from '../contracts/availableViews';
import { resolveOverlayTenantSlug } from '../defectOverlays/tenantDefectOverlayAdapter';
import { surveyDataManagerQueryKeys } from './queryKeys';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function useAvailableViews(
  refreshData: boolean = false,
  enabled: boolean = true,
): UseQueryResult<AvailableViewsResponseBody, SurveyDataManagerApiError> {
  const tenantSlug = resolveOverlayTenantSlug();

  return useQuery<AvailableViewsResponseBody, SurveyDataManagerApiError>({
    queryKey: surveyDataManagerQueryKeys.availableViews(tenantSlug),
    queryFn: () => getAvailableViews(refreshData, { tenantId: tenantSlug }),
    staleTime: FIVE_MINUTES_MS,
    enabled: enabled && tenantSlug != null,
  });
}
